/* eslint-disable eqeqeq */
import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Icon from '@mdi/react'
import {
  mdiArrowBottomLeft,
  mdiArrowTopRight,
  mdiFileDocumentOutline,
} from '@mdi/js'

import colors from '../../../assets/colors'
import { dateFormatedPT, exportFormatedMoney } from '../../../util/utils'

// billingType.type: 1 = saída (subtrai) · 2 = entrada (soma)
const isIncome = billing => billing?.billingType?.type == 2

// Data no formato "Seg, 20/07/2026" (dia da semana abreviado + dd/MM/yyyy).
const WEEKDAYS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

const formatStatementDate = data => {
  if (!data) return ''
  const date = data.length <= 10 ? new Date(`${data} 10:00:00`) : new Date(data)
  return `${WEEKDAYS[date.getDay()]}, ${dateFormatedPT(data)}`
}

const useStyles = makeStyles({
  container: {
    width: '100%',
    maxHeight: 650,
    overflowY: 'auto',
    // border: `1px solid ${colors.graylight}`,
    // borderRadius: 8,
    background: '#fff',
  },
  dayGroup: {
    // '&:not(:last-child)': {
    //   borderBottom: `1px solid ${colors.lightGray}`,
    // },
    padding: '0px 16px 0 0',
  },
  dayHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    padding: '10px 0px',
    background: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 1,
    borderBottom: `1px solid ${colors.lightGray}`,
  },
  dayDate: {
    fontSize: 14,
    fontWeight: 600,
    color: colors.primary,
    textTransform: 'capitalize',
  },
  dayBalanceLabel: {
    fontSize: 15,
    color: colors.textGray,
    fontWeight: 600,
    marginRight: 4,
  },
  dayBalanceValue: {
    color: colors.textGray,
    fontSize: 15,
    fontWeight: 600,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '12px 0px',
    '&:not(:last-child)': {
      borderBottom: `1px solid ${colors.lightGray}`,
    },
  },
  iconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 34,
    width: 34,
    height: 34,
    borderRadius: '50%',
  },
  iconIn: { background: colors.bgSucess },
  iconOut: { background: colors.bgError },
  rowInfo: {
    flex: 1,
    minWidth: 0,
  },
  description: {
    fontSize: 14,
    color: colors.primary,
    fontWeight: 500,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  meta: {
    fontSize: 12,
    color: colors.textGray,
    marginTop: 2,
  },
  value: {
    fontSize: 15,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    textAlign: 'right',
  },
  positive: { color: colors.sucess },
  negative: { color: colors.error },
  empty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    padding: '48px 16px',
    color: colors.textGray,
  },
})

export default function BankStatement({ data = [] }) {
  const classes = useStyles()

  if (!data?.length) {
    return (
      <Box className={classes.empty}>
        <Icon
          path={mdiFileDocumentOutline}
          size={1.6}
          color={colors.graylight}
        />
        <Typography style={{ color: colors.textGray }}>
          Nenhum lançamento no período selecionado.
        </Typography>
      </Box>
    )
  }

  return (
    <Box className={classes.container}>
      {data.map(day => (
        <Box key={day.date} className={classes.dayGroup}>
          <Box className={classes.dayHeader}>
            <Typography className={classes.dayDate}>
              {formatStatementDate(day.date)}
            </Typography>
            <Box display="flex" alignItems="center">
              <span className={classes.dayBalanceLabel}>Saldo</span>
              <span className={`${classes.dayBalanceValue}`}>
                {exportFormatedMoney(day.finalBalance)}
              </span>
            </Box>
          </Box>

          {day.billings?.map(billing => {
            const income = isIncome(billing)
            const amount = Math.abs(Number(billing.value) || 0)
            return (
              <Box key={billing.id} className={classes.row}>
                <Box
                  className={`${classes.iconWrap} ${
                    income ? classes.iconIn : classes.iconOut
                  }`}
                >
                  <Icon
                    path={income ? mdiArrowBottomLeft : mdiArrowTopRight}
                    size={0.8}
                    color={income ? colors.sucess : colors.error}
                  />
                </Box>

                <Box className={classes.rowInfo}>
                  <Typography className={classes.description}>
                    {[billing.billingType?.name, billing.supplier]
                      .filter(Boolean)
                      .join(' • ')}
                  </Typography>
                  {/* <Typography className={classes.meta}>
                    {billing.description || 'Sem descrição'}
                  </Typography> */}
                </Box>

                <Typography
                  className={`${classes.value} ${
                    income ? classes.positive : classes.negative
                  }`}
                >
                  {income ? '+ ' : '- '}
                  {exportFormatedMoney(amount)}
                </Typography>
              </Box>
            )
          })}
        </Box>
      ))}
    </Box>
  )
}
